import "./App.css";

import { Routes, Route, BrowserRouter, useLocation } from "react-router-dom";
import { Suspense, lazy, useEffect } from "react";
import Navbar from "assets/Navbar";
import MobileBottomNav from "assets/MobileBottomNav";
import ScreenScrollToTop from "components/ScreenScrollToTop";
import { SettingsProvider } from "./context/SettingsContext";
import { fbTrack } from "utils/fbPixel";

// Route-level code splitting: each page only downloads its own JS chunk
// when that route is actually visited, instead of every page's code
// being bundled into the single main.js loaded on first paint.
const Dashboard = lazy(() => import("./pages/dashboard"));
const AddCartDetails = lazy(() => import("pages/addCartDetails"));
const ProductDetails = lazy(() => import("pages/productDetails"));
const OrderDetails = lazy(() => import("pages/orderDetails"));
const HotOffer = lazy(() => import("pages/hotOffer"));
const ConfirmOrder = lazy(() => import("pages/confirmOrder"));
const CategoryWiseData = lazy(() => import("pages/categoryWiseData"));
const NewProductsFullPage = lazy(() => import("pages/newProductsFullPage"));
const TrendingProductsFullPage = lazy(() =>
  import("pages/TrendingProductsFullPage"),
);
const FreeDeliveryFullPage = lazy(() => import("pages/FreeDeliveryFullPage"));
const AboutUs = lazy(() => import("pages/aboutUs"));
const ContactUs = lazy(() => import("pages/contactUs"));
const TermsCondition = lazy(() => import("pages/termsCondition"));
const LandingPage = lazy(() => import("pages/landingpage"));

function RouteFallback() {
  return (
    <div className="flex min-h-[60vh] w-full items-center justify-center">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-blue-600 border-t-transparent" />
    </div>
  );
}

function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "page_view",
      page_path: location.pathname,
    });

    console.log("page_view fired", location.pathname);

    if (location.pathname === "/" || location.pathname === "/home") {
      fbTrack("PageView");
    }
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <SettingsProvider>
      <BrowserRouter>
        {/*<ContactUsFloatingButton />*/}
        <PageTracker />
        <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/landingpage/:slug" exact element={<LandingPage />} />
          <Route
            path="*"
            element={
              <>
                <Navbar />
                <div className="pb-0 md:pb-0 select-none">
                  <Routes>
                    <Route path="/" exact element={<Dashboard />}></Route>
                    <Route path="/home" exact element={<Dashboard />}></Route>
                    <Route
                      path="/category/:catalogueId"
                      exact
                      element={<CategoryWiseData />}
                    />
                    <Route
                      path="/details/:category/:id"
                      exact
                      element={<ProductDetails />}
                    ></Route>
                    <Route path="/hotOffer" exact element={<HotOffer />}></Route>
                    <Route
                      path="/allNewProduct"
                      exact
                      element={<NewProductsFullPage />}
                    ></Route>
                    <Route
                      path="/trendingProducts"
                      exact
                      element={<TrendingProductsFullPage />}
                    ></Route>
                    <Route
                      path="/freeDeliveryProducts"
                      exact
                      element={<FreeDeliveryFullPage />}
                    ></Route>
                    <Route path="/cart" exact element={<AddCartDetails />}></Route>
                    <Route
                      path="/orderDetails"
                      exact
                      element={<OrderDetails />}
                    ></Route>
                    <Route
                      path="/confirmOrder"
                      exact
                      element={<ConfirmOrder />}
                    ></Route>
                    <Route path="/aboutUs" exact element={<AboutUs />}></Route>
                    <Route path="/contactUs" exact element={<ContactUs />}></Route>
                    <Route
                      path="/terms&condition"
                      exact
                      element={<TermsCondition />}
                    ></Route>
                  </Routes>
                </div>
                <ScreenScrollToTop />

                {/* <FooterSection /> */}
                <MobileBottomNav />
              </>
            }
          />
        </Routes>
        </Suspense>
      </BrowserRouter>
    </SettingsProvider>
  );
}

export default App;
